/* @ngInject */
function validFile() {
  return {
    require: 'ngModel',
    link: (scope, el, attrs, ngModel)=> {
      el.bind('change', () => {
        scope.$apply(() => {
          ngModel.$setViewValue(el.val());
          ngModel.$render();
        });
      });
    },
  };
}

export default validFile;



// WEBPACK FOOTER //
// ./client/components/valid-file/valid-file.directive.js